module.exports = __webpack_public_path__ + "static/media/logo-white-with-name.837fb3ae.png";